module.exports = __webpack_public_path__ + "img/SKMG14_sticker1.6f88ead6.jpg";